module.exports = __webpack_public_path__ + "static/img/图片13.0ec7df03.png";